module.exports = __webpack_public_path__ + "static/media/indigo-note-text.4e9ad09d.svg";